import { CartProvider } from "./store/context/CartContext";
import Dashboard from "./layouts/Dashboard/Dashboard";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect } from "react";
import { initAxios } from "./modules/axiosInstance";
import { SnackbarProvider } from "notistack";
import { useNotifier } from "../src/hooks/useNotifier";

function AxiosInitializer() {
  const notify = useNotifier();

  useEffect(() => {
    initAxios((msg) => {
      notify(msg, "error");
    });
  }, [notify]);

  return null;
}

const App = () => {
  const defaultTheme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#D0749B",
      },
      secondary: {
        main: "#F69195",
      },
    },
    typography: {
      fontFamily: '"Inter", Helvetica, sans-serif !important',
    },
  });

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={4000}
      preventDuplicate
      hideIconVariant // ← oculta la ❌ automática
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <AxiosInitializer />
      <ThemeProvider theme={defaultTheme}>
        <CartProvider>
          <Dashboard />
        </CartProvider>
      </ThemeProvider>
    </SnackbarProvider>
  );
};

export default App;
